import { App, useCurrentApp, useIntl } from '@finn/ui-utils';
import { useMemo } from 'react';

import { FilterKey } from '../../../core';
import { FiltersState } from '../../../filters-management';
import { FilterTestID } from '../../helpers';
import { useTrackFilterCategoryClicked } from '../../tracking';
import { MiscFilter } from '../atoms/MiscFilter';
import { FilterOptionClickFunction } from '../grouped-filters/FiltersGroup';

type OptionsFilterProps = {
  selectedFilters: FiltersState;
  onOptionClick: FilterOptionClickFunction;
};

type FilterData = {
  filterKey: FilterKey[];
  availableFilterValues: string[];
};

export function OptionsFilter({
  selectedFilters,
  onOptionClick,
}: OptionsFilterProps) {
  const i18n = useIntl();
  const isB2BApp = useCurrentApp() === App.B2B;
  const trackFilterOpen = useTrackFilterCategoryClicked('miscellaneous');

  const filterData: FilterData = useMemo(() => {
    const allKeysAndValues = isB2BApp
      ? [
          {
            key: FilterKey.MONTHLY_PAYMENT_OF_SERVICE_FEE,
            value: i18n.formatMessage('plp.monthlyPaymentOfServiceFee'),
          },
        ]
      : [
          {
            key: FilterKey.IS_YOUNG_DRIVER,
            value: i18n.formatMessage('plp.isYoungDriver'),
          },
          {
            key: FilterKey.MONTHLY_PAYMENT_OF_SERVICE_FEE,
            value: i18n.formatMessage('plp.monthlyPaymentOfServiceFee'),
          },
        ];

    return {
      filterKey: allKeysAndValues.map((item) => item.key),
      availableFilterValues: allKeysAndValues.map((item) => item.value),
    };
  }, [i18n]);

  if (!filterData.availableFilterValues.length) {
    return null;
  }

  const selectedOptions = isB2BApp
    ? [Boolean(selectedFilters.monthly_payment_of_service_fee)]
    : [
        Boolean(selectedFilters.is_young_driver),
        Boolean(selectedFilters.monthly_payment_of_service_fee),
      ];

  return (
    <MiscFilter
      data={filterData}
      onOpen={trackFilterOpen}
      onOptionClick={onOptionClick}
      selectedValues={selectedOptions}
      title={i18n.formatMessage('plp.miscellaneous')}
      testId={FilterTestID.OptionsFilter}
    />
  );
}
